export const BASE_URL = 'https://www.every.org/';
export const BASE_API_URL = 'https://partners.every.org/v0.2/nonprofit';

export const STAGING_BASE_URL = 'https://staging.every.org/';
export const STAGING_API_URL =
	'https://partners-staging.every.org/v0.2/nonprofit';

export const getSiteUrl = (staging?: boolean) =>
	staging ? STAGING_BASE_URL : BASE_URL;
export const getApiUrl = (staging?: boolean) =>
	staging ? STAGING_API_URL : BASE_API_URL;

export const BASE_CLOUDINARY_URL =
	'https://res.cloudinary.com/everydotorg/image/upload/';
export const BASE_COINGECKO_URL = 'https://api.coingecko.com/api/v3';

export const SUPPORT_EMAIL = 'support@every.org';
export const TEAM_EMAIL = 'team@every.org';
export const CRYPTO_EMAIL = 'crypto@every.org';

export const TERMS_ROUTE = 'terms';
export const HELP_ROUTE = 'support';
export const PRIVACY_ROUTE = 'privacy';
export const ABOUT_ROUTE = 'about-us';
export const FUNDRAISER_ROUTE = 'fundraiser';
export const GIFT_CARD_ROUTE = 'gift';

export const TERMS_URL = BASE_URL + TERMS_ROUTE;
export const HELP_URL = BASE_URL + HELP_ROUTE;
export const PRIVACY_URL = BASE_URL + PRIVACY_ROUTE;
export const ABOUT_URL = BASE_URL + ABOUT_ROUTE;
export const GIFT_CARD_URL = BASE_URL + GIFT_CARD_ROUTE;
